import { createRequestHelper } from '@utils/swr'
import queryString from 'query-string'
import { type PopupExpiredCheckQueryParams } from '../types/apiRequest'
import { type PopupExpiredCheckResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useRequest,
} = createRequestHelper<FortuneApis['get']['popupExpiredCheck'], PopupExpiredCheckResponse, PopupExpiredCheckQueryParams>({
  client: 'eCommerce',
  key: (params) => {
    const queryParamsObject = {
      country_code: params?.country_code,
      project_code: params?.project_code,
      campaign_id: params?.campaign_id,
      last_updated_time: params?.last_updated_time,
    }
    const query = queryString.stringify(queryParamsObject, {
      skipNull: true,
      skipEmptyString: true,
    })
    const queryParams = query ? `?${query}` : ''
    return `/popups/expired-check${queryParams}`
  },
  isImmutable: true,
})

export const useApiPopupExpiredCheck = useRequest
